export default __webpack_public_path__ + "static/media/Ensar.01d83eac.jpg";